<script>
export default {
    name: "AddressHeader",
    

data(){
    return{
        companydetails:this.$root.companydetails,
    };
}

}
</script>
<template>
    <div class="w-full">

      
        <!-- <div class="flex items-center justify-center pb-2" ><img  src="./Logo/kisiispecialistlogo.png"></div> 
    <h5 class="font-bold text-center text-sm"> Racecourse Hospital</h5>
      <h5 class="font-bold text-center text-sm"> P.O BOX 4249 Eldoret Kenya</h5>
      <h5 class="font-bold text-center text-sm"> Tel: 0726 773 876</h5>
      <h5 class="font-bold text-center text-sm"> Email: racecoursehospital@gmail.com</h5>
      <h5 class="font-bold text-center text-xs"> (Ole Tepes Road Off Eldoret-Kapsabet Road Next to Chinese Garage)</h5> -->

    <div class="flex items-center justify-center pb-2" ><img :src="companydetails.logoUrl"></div> 
      <h5 class="font-bold text-center">{{companydetails.company}}</h5>
      <h5 class="font-bold text-center">{{companydetails.postalAddress}}</h5>
      <h5 class="font-bold text-center">{{companydetails.cellphone}}</h5>
     <h5 class="font-bold text-center">{{companydetails.email}}</h5>
     <h5 class="font-bold text-center">{{companydetails.physicalAddress}}</h5> 
      

      <!--<div class="flex items-center justify-center pb-2" ><img  src="./Logo/demo.jpg"></div>
         <h5 class="font-bold text-center">Demo Hospital Limited</h5>
      <h5 class="font-bold text-center">P.O BOX 3492-40200</h5>
      <h5 class="font-bold text-center">CELL: 0732 749146/ 0795-006615</h5>
      <h5 class="font-bold text-center">demo.hospital@yahoo.com</h5>
      <h5 class="font-bold text-center">Xyz (Trd RD)</h5> -->

      <!-- <div class="flex items-center justify-center pb-2" ><img  src="./Logo/nsh2.png"></div>
         <h5 class="font-bold text-center">THE NAKURU SPECIALIST HOSPITAL</h5>
      <h5 class="font-bold text-center">P.O BOX 19459-20100, NAKURU</h5>
      <h5 class="font-bold text-center">CELL: 0700 907 000</h5>
      <h5 class="font-bold text-center">info@nsh.co.ke</h5> -->

      
         <!-- <h5 class="font-bold text-center pb-2">Nyangena Medical & Dental Clinic</h5>
      <h5 class="font-bold text-center">P.O BOX 3492-40200</h5>
      <h5 class="font-bold text-center">CELL: 0737-370558/ 0726688612</h5>
      <h5 class="font-bold text-center">nyangenadental@gmail.com</h5>
      <h5 class="font-bold text-center">Kisii (Nyakongo Towers)</h5> -->
    </div>
</template>


